import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-agcharts-ent',
	templateUrl:'./AgChartsEnterprisePluginPage.html',
	styles: [],
	styleUrls:['./AgChartsEnterprisePluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AgChartsEnterprisePluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_495 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>agcharts-enterprise</artifactId>
</dependency>
\`\`\``;
	mdContent_496 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:agcharts-enterprise:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_497 = `\`\`\`json
"ag-charts-enterprise": "^13.1.0"
\`\`\``;
	mdContent_498 = `\`\`\`java
AgChartsEnterprisePageConfigurator
    .setAG_CHARTS_LICENSE_KEY("YOUR_KEY");

@NgComponent
public class DashboardGauge
        implements INgComponent<DashboardGauge> {
    public AgRadialGaugeOptions<DashboardGauge> gauge() {
        return new AgRadialGaugeOptions<>(this)
            .setValue(75.0)
            .setScale(new AgGaugeScale()
                .setMin(0).setMax(100));
    }
}
\`\`\``;
	mdContent_499 = `\`\`\`java
var chart = new AgCandlestickChart<>();
chart.getOptions()
    .setSeries(List.of(
        new AgCandlestickSeriesOptions<>()
            .setXKey("date")
            .setOpenKey("open")
            .setHighKey("high")
            .setLowKey("low")
            .setCloseKey("close")
    ));
\`\`\``;
	mdContent_500 = `\`\`\`java
// Set license key
AgChartsEnterprisePageConfigurator
    .setAG_CHARTS_LICENSE_KEY("YOUR_KEY");

@NgComponent
public class DashboardGauge
        implements INgComponent<DashboardGauge> {
    public AgRadialGaugeOptions<DashboardGauge> gauge() {
        return new AgRadialGaugeOptions<>(this)
            .setValue(75.0)
            .setScale(new AgGaugeScale()
                .setMin(0).setMax(100));
    }
}
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
